import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { Typography } from '@material-ui/core';
const HeaderTypography = styled(Typography).withConfig({
  displayName: "CardHeaderTab__HeaderTypography",
  componentId: "sc-194r9df-0"
})(["", ";"], props => props.theme.palette.text.title ? css(["&.MuiTypography-colorTextSecondary{color:", ";}"], props.theme.palette.text.title) : '');
export const HeaderTab = styled.div.withConfig({
  displayName: "CardHeaderTab__HeaderTab",
  componentId: "sc-194r9df-1"
})(["background:", ";position:relative;width:fit-content;padding:4px 8px;cursor:pointer;border-bottom:", ";color:", ";border-top-left-radius:6px;border-top-right-radius:6px;", " &:before,&:after{position:absolute;bottom:-1px;width:6px;height:6px;content:' ';}&:before{border-bottom-right-radius:6px;box-shadow:2px 2px 0 ", ";left:-6px;}&:after{border-bottom-left-radius:6px;box-shadow:-2px 2px 0 ", ";right:-6px;}", " @media print{&{border-bottom:3px solid ", ";margin-bottom:-3;}&:before{box-shadow:2px 2px 0 ", ";}&:after{box-shadow:-2px 2px 0 ", ";}}"], props => props.theme.palette.background.header, props => props.active ? `1px solid ${props.theme.palette.text.secondary}` : '', props => props.disabled ? 'rgba(255, 255, 255, 0.3)' : '', props => typeof props['data-adjust-bottom'] === 'number' ? `bottom: ${props['data-adjust-bottom']}px;` : '', props => props.theme.palette.background.header, props => props.theme.palette.background.header, props => props.theme.props.styledPrintRules.header, props => props.theme.props.styledPrintRules.headerColor, props => props.theme.props.styledPrintRules.headerColor, props => props.theme.props.styledPrintRules.headerColor);
export const CardHeaderTab = ({
  bottom,
  patient,
  disabled,
  children,
  handleClick,
  active
}) => /*#__PURE__*/React.createElement(HeaderTab, {
  onClick: handleClick,
  disabled: disabled,
  active: active,
  "data-adjust-bottom": bottom
}, /*#__PURE__*/React.createElement(HeaderTypography, {
  variant: "h6",
  color: disabled ? 'inherit' : 'textSecondary'
}, patient ? /*#__PURE__*/React.createElement(Fragment, null, patient.firstName, " ", patient.lastName, " (#", patient.patientNumber, ")") : children));
export default CardHeaderTab;